import { render, staticRenderFns } from "./admin-manual-sponsored-postings.vue?vue&type=template&id=9f4a3b58&scoped=true&"
import script from "./admin-manual-sponsored-postings.ts?vue&type=script&lang=ts&"
export * from "./admin-manual-sponsored-postings.ts?vue&type=script&lang=ts&"
import style0 from "./admin-manual-sponsored-postings.vue?vue&type=style&index=0&id=9f4a3b58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4a3b58",
  null
  
)

export default component.exports